<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="TITLE"><a id="_idTOCAnchor-4"></a>With All Our Prayers</p>
<p class="SUBTITLE">Walking with God <br/>through the Christian Year</p>
<p class="AUTHOR">John B. Rogers Jr.</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
<p class="COPYRIGHT">© 2015 John B. Rogers Jr.<br/>All rights reserved<br/><br/>Published 2015 by<br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge CB3 9PU U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Rogers, John B., 1941-<br/>With all our prayers: walking with God through the Christian year /<br/>John B. Rogers, Jr.<br/>pages   cm<br/>ISBN 978-0-8028-7191-6 (pbk.: alk. paper)<br/>eISBN 978-1-4674-4322-7 (ePub)<br/>eISBN 978-1-4674-4282-4 (Kindle)<br/>1. Pastoral prayers. 2. Prayers. 3. Church year — Prayers and devotions.<br/>4. Public worship. I. Title.<br/><br/>BV250.R65 2015<br/>264<span class="CharOverride-1">′</span>.13 — dc23<br/>                        2014040381</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
<p class="DEDICATION">Dedicated to<br/><br/>Covenant Presbyterian Church<br/>Charlotte, North Carolina<br/><br/>First Presbyterian Church<br/>Shreveport, Louisiana<br/><br/>Davidson College Presbyterian Church<br/>Davidson, North Carolina<br/><br/>First Presbyterian Church<br/>Durham, North Carolina<br/><br/>“I thank my God in all my remembrance of you, always in every prayer of mine for you all making my prayer with joy, thankful for your partnership in the gospel . . . And I am sure that God who began a good work in you will bring it to completion at the day of Jesus Christ.”<br/>(Phil. 1:3-6, RSV)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Rogers_With_All_Our_Prayers_text_CC.vue?797ceaf2